module.exports = __webpack_public_path__ + "static/media/icon_help_header.c87a47c7.svg";